var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-empty',{attrs:{"description":"已跳转到数据大屏"}})
}
var staticRenderFns = []

export { render, staticRenderFns }